var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.833252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6665H29",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.6665H26",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.6665H22",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.12eee2007a42fc97d117c4a5b910b31e.svg";
export { ForwardRef as ReactComponent };